var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailedEligibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6083_15087)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 39.5,
    r: 34.4125,
    stroke: "#314064",
    strokeWidth: 2.175
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5 68C55.2401 68 68 55.2401 68 39.5C68 23.7599 55.2401 11 39.5 11C23.7599 11 11 23.7599 11 39.5",
    stroke: "#799DD2",
    strokeWidth: 2.175,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6083_15087)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.2068 28.2932C52.0193 28.1057 51.7649 28.0004 51.4998 28.0004C51.2346 28.0004 50.9803 28.1057 50.7928 28.2932L40.4998 38.5862L30.2068 28.2932C30.0193 28.1057 29.765 28.0004 29.4998 28.0004C29.2346 28.0004 28.9803 28.1057 28.7928 28.2932C28.6053 28.4807 28.5 28.735 28.5 29.0002C28.5 29.2653 28.6053 29.5196 28.7928 29.7072L39.0858 40.0002L28.7928 50.2932C28.6053 50.4807 28.5 50.735 28.5 51.0002C28.5 51.2653 28.6053 51.5196 28.7928 51.7072C28.9803 51.8946 29.2346 51.9999 29.4998 51.9999C29.765 51.9999 30.0193 51.8946 30.2068 51.7072L40.4998 41.4142L50.7928 51.7072C50.9803 51.8946 51.2346 51.9999 51.4998 51.9999C51.7649 51.9999 52.0193 51.8946 52.2068 51.7072C52.3943 51.5196 52.4996 51.2653 52.4996 51.0002C52.4996 50.735 52.3943 50.4807 52.2068 50.2932L41.9138 40.0002L52.2068 29.7072C52.3943 29.5196 52.4996 29.2653 52.4996 29.0002C52.4996 28.735 52.3943 28.4807 52.2068 28.2932Z",
    fill: "#314064"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6083_15087"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6083_15087"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(28.5 28)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedEligibility);
export default __webpack_public_path__ + "static/media/failed-eligibility.d4a4bbadae6d6bc6e6e68d122bb9ca85.svg";
export { ForwardRef as ReactComponent };